'use client';

import { Label } from 'react-aria-components/Label';
import { cn } from '../../utils/cn';
import type React from 'react';

export interface InputWithLabelProps {
    label?: string | React.ReactNode;
    optionalLabel?: string;
    isRequired?: boolean;
    showRequiredIndicator?: boolean;
}

export interface InputLabelProps extends InputWithLabelProps {
    className?: string;
    labelId?: string;
    htmlFor?: string;
}

export function InputLabel({
    label,
    optionalLabel,
    isRequired,
    showRequiredIndicator = true,
    className,
    labelId,
    htmlFor
}: InputLabelProps) {
    if (!label) return null;

    return (
        <div className={cn('flex items-center gap-lr-spacing-050', className)}>
            <Label
                id={labelId}
                htmlFor={htmlFor}
                className={cn(
                    'flex gap-lr-spacing-025 text-lr-text-main',
                    `
                        text-lr-subtitle-tight-medium
                        lr-md:text-lr-subtitle-compact-medium
                    `,
                    showRequiredIndicator &&
                        `in-data-[required]:after:text-lr-text-brand-accent in-data-[required]:after:content-["*"]`
                )}
                data-required={isRequired || undefined}
            >
                {label}
            </Label>
            {!!optionalLabel && (
                <span
                    className={cn(`
                        text-lr-subtitle-tight-light text-lr-text-subtle
                        lr-md:text-lr-subtitle-compact-light
                    `)}
                >
                    {optionalLabel}
                </span>
            )}
        </div>
    );
}
